import { Message, IMessage } from "./Message";


export interface ISticker {
    Blob:string;
    MimeType:string;
    Preview:string;
    DisplayName: string;
}

export interface IStickerMessage extends IMessage {
   
    Sticker : ISticker;
}

export const StickerMessage = (props: IStickerMessage) => {



    return <>
    
        <Message {...props} >
        <div className="row">
            <img src={ props.Sticker.Preview } className="img-fluid" alt={props.Sticker.DisplayName}/>
        </div>
        </Message>

    </>

}